import { useRoutes } from "react-router-dom";

import { mainRoutes } from "./main";

// ----------------------------------------------------------------------

export default function RouterComponent() {
  return useRoutes([
    // Main routes
    ...mainRoutes,
  ]);
}
